
import { defineComponent, reactive, onMounted, toRefs, computed } from 'vue'
import f10ApiHk from '@/api/f10ApiHk'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => ({})
    },
    token: {
      type: String,
      default: ''
    }
  },
  components: { Table, Nodata },

  setup(props) {
    const route = useRoute()
    const pageData = reactive({
      rawData: [] as any[],
      filterType: 'all', // 默认选中"过滤不分红"
      columns: [
        {
          title: '报告期',
          dataIndex: 'formattedDate',
          key: 'formattedDate',
          width: '120px',
          align: 'center'
        },
        {
          title: '进度',
          dataIndex: 'planSchedule',
          key: 'planSchedule',
          width: '120px',
          align: 'center'
        },
        {
          title: '分红方案',
          dataIndex: 'planExplain',
          key: 'planExplain',
          width: '200px',
          align: 'center'
        },
        {
          title: '除净日',
          dataIndex: 'formattedExDate',
          key: 'formattedExDate',
          width: '200px',
          align: 'center'
        },
        {
          title: '派息日',
          dataIndex: 'formattedDividendDate',
          key: 'formattedDividendDate',
          width: '200px',
          align: 'center'
        }
      ],
      spinning: true
    })

    // 格式化日期
    const formatDate = (timestamp: number | null) => {
      if (!timestamp) return '-'
      const date = new Date(timestamp)
      return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
    }

    // 格式化报告期
    const formatReportPeriod = (record: any) => {
      const year = new Date(record.reportDate).getFullYear()
      return `${year}${record.reportPeriodType}`
    }

    // 处理API数据
    const processApiData = (data: any[]) => {
      return data.map(item => ({
        ...item,
        formattedDate: formatReportPeriod(item),
        formattedExDate: formatDate(item.exDate),
        formattedDividendDate: formatDate(item.dividendDate)
      }))
    }

    // 过滤后的数据
    const filteredData = computed(() => {
      if (pageData.filterType === 'excludeNoDividend') {
        return pageData.rawData.filter(item => item.planExplain !== '不分红')
      }
      return pageData.rawData
    })

    // 过滤数据
    const filterData = () => {
      // 过滤逻辑已在computed中实现
    }

    onMounted(() => {
      const data = {
        data: {
          // market: 'HK',
          // symbol: '00700'
          market: route.query.market || 'HK',
          symbol: route.query.code || '00700',
        },
        headers: {
          token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944'
        }
      }

      f10ApiHk.getBriefStockDividend(data).then((res: any) => {
        if (res.data && res.data) {
          console.log('res分红派息', res.data)
          pageData.rawData = processApiData(res.data?.stockBonus)
        }
        pageData.spinning = false
      }).catch(() => {
        pageData.spinning = false
      })
    })

    return {
      ...toRefs(pageData),
      filteredData,
      filterData
    }
  }
})
